import { createContext, useContext, useState } from "react";

const UIContext = createContext(null);

export const UIProvider = ({ children }) => {
  const [askOpen, setAskOpen] = useState(false);
  return (
    <UIContext.Provider value={{ askOpen, setAskOpen }}>
      {children}
    </UIContext.Provider>
  );
};

export const useUI = () => useContext(UIContext);
